import { z } from 'zod';
import { InvoiceSchema } from './invoice.js';
import { BillSchema } from './bill.js';
import { CreateBillEventResponseSchema, CreateInvoiceEventResponseSchema, DownloadInvoiceEventResponseSchema, ErrorResponseSchema, ServiceHookEventsSchema, } from './serviceDiscoveryEvents.js';
export const ImplementorInvoiceResponseSchema = InvoiceSchema;
export const ImplementorBillResponseSchema = BillSchema;
export const ImplementorResponseSchema = z.union([
    CreateInvoiceEventResponseSchema,
    DownloadInvoiceEventResponseSchema,
    CreateBillEventResponseSchema,
    ErrorResponseSchema,
]);
export const ImplementorRequestSchema = z.object({
    event: ServiceHookEventsSchema,
    requestActor: z.string(),
});
export const PreReqsRequestSchema = z.object({
    event: ServiceHookEventsSchema,
    requestActor: z.string(),
});
export const PreReqsResponseSchema = z.object({
    result: z.boolean(),
    reasons: z.string().array().optional(),
});
export const AddtlParamsRequestSchema = z.object({
    event: ServiceHookEventsSchema,
    requestActor: z.string(),
});
export const AddtlParamsResponseSchema = z
    .object({
    event: ServiceHookEventsSchema,
    requestActor: z.string(),
})
    .partial();
